import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RewindIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.956 10.478C12.7941 10.5995 12.6626 10.7571 12.572 10.9382C12.4815 11.1193 12.4343 11.319 12.4343 11.5215C12.4343 11.7239 12.4815 11.9236 12.572 12.1048C12.6626 12.2859 12.7941 12.4434 12.956 12.5649L19.9131 17.7821C20.1069 17.9274 20.3373 18.0159 20.5786 18.0376C20.8198 18.0594 21.0624 18.0135 21.279 17.9052C21.4957 17.7969 21.6779 17.6304 21.8052 17.4243C21.9325 17.2183 22 16.9808 22 16.7386V6.30429C22 6.06207 21.9325 5.82463 21.8052 5.61859C21.6779 5.41254 21.4957 5.24602 21.279 5.1377C21.0624 5.02937 20.8198 4.98352 20.5786 5.00527C20.3373 5.02702 20.1069 5.11553 19.9131 5.26086L12.9574 10.478H12.956ZM2.52172 10.478C2.35973 10.5995 2.22825 10.7571 2.1377 10.9382C2.04714 11.1193 2 11.319 2 11.5215C2 11.7239 2.04714 11.9236 2.1377 12.1048C2.22825 12.2859 2.35973 12.4434 2.52172 12.5649L9.4788 17.7821C9.67258 17.9274 9.903 18.0159 10.1442 18.0376C10.3855 18.0594 10.628 18.0135 10.8447 17.9052C11.0613 17.7969 11.2435 17.6304 11.3709 17.4243C11.4982 17.2183 11.5657 16.9808 11.5657 16.7386V6.30429C11.5657 6.06207 11.4982 5.82463 11.3709 5.61859C11.2435 5.41254 11.0613 5.24602 10.8447 5.1377C10.628 5.02937 10.3855 4.98352 10.1442 5.00527C9.903 5.02702 9.67258 5.11553 9.4788 5.26086L2.52172 10.478Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

RewindIcon.displayName = 'RewindIcon';
